let env = process.env.REACT_APP_NODE_ENV || 'dev';

const graphQl_endPoints = {
  dev: {
    DBT: 'https://e2xgr5csbfdktn7fclvowpkery.appsync-api.us-east-1.amazonaws.com/graphql',
    SWASTH: 'https://ybudbtbn75hgje3ael2kau7zk4.appsync-api.us-east-1.amazonaws.com/graphql',
    BTPORTAL: 'https://dm5eeo6xu5hk5b4mxndttoygcy.appsync-api.us-east-1.amazonaws.com/graphql',
    ACT: 'https://gqp47ccpmjfubj2pgyulmqwkme.appsync-api.us-east-1.amazonaws.com/graphql',

    APIGATEWAY: {
      BTPORTAL: 'https://b01gajytu1.execute-api.us-east-1.amazonaws.com/test/portal',
      CREATECLAIM: 'https://b01gajytu1.execute-api.us-east-1.amazonaws.com/test/createClaim',
      EMAILVALIDATE:'https://rtw0yzegbl.execute-api.us-east-1.amazonaws.com/dev/portal',
    },
    profileImageBucket: 'better-therapist-profile',
    swasthBucket: 'swasthcomobileapp-userfiles-mobilehub-1666206195',
    eligible: {
      apiKey: 'sS7l7bfBZDanqT1CSGbGzT2UMCJqGhhK5w7U'
    }
  },
  prod: {
    DBT: 'https://z5qqv4eqnrcvjlpqdr4bjekmkm.appsync-api.us-east-1.amazonaws.com/graphql',
    SWASTH: ' https://haf7cr5vtvg7xk2ebhd3hfi2iq.appsync-api.us-east-1.amazonaws.com/graphql',
    BTPORTAL: 'https://ny2rt53wx5g6zde7q2c7iuadxm.appsync-api.us-east-1.amazonaws.com/graphql',
    ACT: 'https://6bzscxb2mbfobos7qqode5m3e4.appsync-api.us-east-1.amazonaws.com/graphql',

    APIGATEWAY: {
      BTPORTAL: 'https://wwi7qbph42.execute-api.us-east-1.amazonaws.com/prod-new/portal',
      EMAILVALIDATE:'https://rtw0yzegbl.execute-api.us-east-1.amazonaws.com/dev/portal',
      CREATECLAIM: 'https://wwi7qbph42.execute-api.us-east-1.amazonaws.com/prod-new/createClaim'
    },
    profileImageBucket: 'better-therapists',
    swasthBucket: 'swasth-userfiles-mobilehub-1095358790',
    eligible: {
      apiKey: 'sS7l7bfBZDanqT1CSGbGzT2UMCJqGhhK5w7U'
    }
  },
};
export default (env === "dev" ? graphQl_endPoints.dev : graphQl_endPoints.prod);
